// Interpreta os eventos de window.postMessage que o popup do Embedded Signup
// da Meta (ES v4) manda pra janela pai durante o fluxo de login com Facebook.
//
// O MESMO canal (window "message") também carrega outros eventos internos do
// SDK do Facebook que não são JSON (ex.: handshakes do próprio iframe/popup) —
// por isso o parse é silencioso: qualquer coisa que não seja o formato
// esperado simplesmente devolve null, em vez de derrubar o listener com uma
// exceção não tratada.

// A checagem de origin é a ÚNICA defesa contra uma página maliciosa forjando
// WA_EMBEDDED_SIGNUP/FINISH via postMessage — por isso não pode ser um
// endsWith('facebook.com') solto: isso aceitaria 'https://evilfacebook.com'
// (falta o ponto separador de subdomínio). Exige https:// + domínio exato
// www.facebook.com OU subdomínio real (*.facebook.com, com o ponto).
const ALLOWED_EXACT_ORIGIN = 'https://www.facebook.com'
const ALLOWED_SUBDOMAIN_SUFFIX = '.facebook.com'

function isAllowedOrigin(origin) {
  if (!origin.startsWith('https://')) return false
  return origin === ALLOWED_EXACT_ORIGIN || origin.endsWith(ALLOWED_SUBDOMAIN_SUFFIX)
}

export function parseEmbeddedSignupMessage(event) {
  if (!event || typeof event.origin !== 'string') return null

  if (!isAllowedOrigin(event.origin)) return null

  let payload
  try {
    payload = JSON.parse(event.data)
  } catch (error) {
    // evento não-JSON no mesmo canal — ignora silenciosamente
    return null
  }

  if (!payload || typeof payload !== 'object') return null
  if (payload.type !== 'WA_EMBEDDED_SIGNUP') return null

  return payload
}

export default { parseEmbeddedSignupMessage }
